module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-708ec58f5678ed0144caac62433ac745.svg";